import { ActionDefinition, AutomationRecordType, FrontendTriggerDefinition } from "@/components/automations/types"

import { ACTION_DEFINITIONS, getActionCatalog, getActionDefinition } from "./actions"
import { getTriggerDefinition, getTriggerDefinitionsForRecordType, TRIGGER_DEFINITIONS } from "./triggers"

export { getActionDefinition, getActionCatalog }
export { getTriggerDefinition, getTriggerDefinitionsForRecordType }

/**
 * Complete automation catalog showing all capabilities by record type
 */
export const AUTOMATION_CATALOG = {
  contact: {
    triggers: TRIGGER_DEFINITIONS.contact,
    actions: ACTION_DEFINITIONS.contact,
    recordTypeLabel: "Contact",
  },
  business: {
    triggers: TRIGGER_DEFINITIONS.business,
    actions: ACTION_DEFINITIONS.business,
    recordTypeLabel: "Business",
  },
  household: {
    triggers: TRIGGER_DEFINITIONS.household,
    actions: ACTION_DEFINITIONS.household,
    recordTypeLabel: "Household",
  },
  task: {
    triggers: TRIGGER_DEFINITIONS.task,
    actions: ACTION_DEFINITIONS.task,
    recordTypeLabel: "Task",
  },
  meeting: {
    triggers: TRIGGER_DEFINITIONS.meeting,
    actions: ACTION_DEFINITIONS.meeting,
    recordTypeLabel: "Meeting",
  },
  opportunity: {
    triggers: TRIGGER_DEFINITIONS.opportunity,
    actions: ACTION_DEFINITIONS.opportunity,
    recordTypeLabel: "Opportunity",
  },
  project: {
    triggers: TRIGGER_DEFINITIONS.project,
    actions: ACTION_DEFINITIONS.project,
    recordTypeLabel: "Project",
  },
  person: {
    triggers: TRIGGER_DEFINITIONS.person,
    actions: ACTION_DEFINITIONS.person,
    recordTypeLabel: "Person",
  },
} as const satisfies Record<
  AutomationRecordType,
  {
    triggers: FrontendTriggerDefinition[]
    actions: ActionDefinition[]
    recordTypeLabel: string
  }
>
